module.exports = __webpack_public_path__ + "img/micon-4.34b6435e.svg";